export default __webpack_public_path__ + "static/media/canada-flag-2x.b40af3b9.png";